<template>
  <ListingBlockLayout title="Books" class="books-block-skeleton">
    <BookCardSkeleton v-for="i in numberOfCardsToRender" :key="i" />
  </ListingBlockLayout>
</template>

<script setup lang="ts">
import ListingBlockLayout from '@/app/components/listing/ListingBlockLayout.vue'
import BookCardSkeleton from '@/app/components/listing/skeleton-loaders/BookCardSkeleton.vue'

const numberOfCardsToRender = 4
</script>

<style lang="scss" scoped>
@import '@/assets.app/css/common/animations.scss';

.books-block-skeleton {
  --listing-block-number-of-columns: 4;
  --listing-block-items-width-mobile: 220px;

  :deep(.listing-header__link) {
    &::after {
      content: '';
      display: inline-block;
      width: 85px;
      height: 34px;
      margin-left: 16px;
      border-radius: 53px;
      border: 1px solid $c-border;
      background-color: $c-bg;
      animation: skeleton-loading 1s linear infinite alternate;
      vertical-align: middle;
      @media only screen and (max-width: $w-tablet-s) {
        width: 101.5px;
        height: 37.5px;
      }
    }
  }
}

.night-mode .books-block-skeleton {
  :deep(.listing-header__link) {
    &::after {
      animation: skeleton-loading-night-mode 1s linear infinite alternate;
    }
  }
}
</style>
